//
//  SDKAlignment.ts
//  Supernova SDK
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Source type enum
export var Alignment;
(function (Alignment) {
    Alignment["left"] = "Left";
    Alignment["center"] = "Center";
    Alignment["stretch"] = "Stretch";
})(Alignment || (Alignment = {}));
export var TextAlignment;
(function (TextAlignment) {
    TextAlignment["left"] = "Left";
    TextAlignment["center"] = "Center";
    TextAlignment["right"] = "Right";
})(TextAlignment || (TextAlignment = {}));
